import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  dialogContainer: {
    minWidth: "500px",
    minHeight: "300px",
    [theme.breakpoints.down("930")]: {
      minWidth: "90%",
    },
  },
  errorMessage: {
    marginTop: "4px",
    fontSize: "8px",
    color: theme.palette.warning.main,
  },
}))

export default styles
